export const HI_SURROGATE_START = 0xd800
export const HI_SURROGATE_END = 0xdbff
export const LOW_SURROGATE_START = 0xdc00
export const LOW_SURROGATE_END = 0xdfff
